import * as React from 'react';
import BttfAxios from '@features/utils/axios';
import IReminder from './IReminder';

import * as style from './ReminderStyles.module.scss'

export default class Reminder extends React.Component<IReminder> {

  buttonClick = () => {
    if (!this.props.block) {
      BttfAxios.post(this.props.path, {}, (res) => {
        if (res.status === 204) {
          this.props.callbackClick(true);
        }
      }, (err) => {
        if (err.response.status === 429) {
          this.props.callbackClick(false, 'Try again in 10 minutes');
        }
      });
    } else {
      this.props.callbackClick(false, 'Try again in 10 minutes');
    }
  }

  render() {
    return (
      <button onClick={this.buttonClick} className={style.reminderBtn}>
        {this.props.text}
      </button>
    );
  }
}
